document.querySelectorAll('[data-paint-browser]').forEach(async root => {
  const modelGrid = root.querySelector('[data-paint-models]');
  const productGrid = root.querySelector('[data-paint-products]');
  const search = root.querySelector('[data-paint-search]');
  const status = root.querySelector('[data-paint-status]');
  const heading = root.querySelector('[data-paint-title]');
  const back = root.querySelector('[data-paint-back]');
  const brand = root.dataset.brand;
  const locale = document.documentElement.lang || 'de';
  const currency = window.Shopify?.currency?.active || 'EUR';
  const money = value => new Intl.NumberFormat(locale,{style:'currency',currency}).format(Number(value));
  const make = (tag, className, text) => {const node=document.createElement(tag); if(className) node.className=className; if(text!==undefined) node.textContent=text; return node;};
  const family = product => {
    let title=product.title;
    if(title.toLowerCase().startsWith(brand.toLowerCase())) title=title.slice(brand.length).replace(/^-Benz/i,'').trim();
    const parts=title.split(/\s+/);
    if(/^(Model|SEAL|SEALION|ID\.|5)$/i.test(parts[0])) return parts.slice(0,2).join(' ');
    return parts[0].split('/')[0];
  };
  let products=[];
  try {
    let page=1;
    while(true){
      const response=await fetch(`${window.Shopify?.routes?.root || '/'}products.json?limit=250&page=${page}`,{headers:{Accept:'application/json'}});
      if(!response.ok) throw new Error('Collection could not be loaded');
      const batch=(await response.json()).products || [];
      products.push(...batch);
      if(batch.length<250) break;
      page++;
    }
    products=products.filter(product=>/lackschutz/i.test(product.product_type || '') && (product.title.toLocaleLowerCase(locale).startsWith(brand.toLocaleLowerCase(locale)+' ') || (brand==='VW' && product.title.startsWith('Volkswagen '))));
    const groups=new Map();
    products.forEach(product=>{const key=family(product);if(!key)return;if(!groups.has(key))groups.set(key,[]);groups.get(key).push(product);});
    const selected=new URLSearchParams(location.search).get('model');
    const entries=[];
    if(selected){
      modelGrid.hidden=true;
      productGrid.hidden=false;
      back.hidden=false;
      heading.textContent=`${brand} ${selected} · ${root.dataset.products}`;
      (groups.get(selected)||[]).forEach(product=>{
        const card=make('a','ns-paint-product');
        card.href=`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}`;
        if(product.images?.[0]){const img=make('img');const source=new URL(product.images[0].src,location.origin);source.searchParams.set('width','640');img.src=source.href;img.alt=product.title;img.loading='lazy';img.width=640;img.height=480;card.append(img);}
        const content=make('div','ns-paint-product__content');
        content.append(make('h2','',product.title));
        const available=product.variants.filter(variant=>variant.available);
        const variants=available.length?available:product.variants;
        const price=Math.min(...variants.map(variant=>Number(variant.price)));
        content.append(make('span','ns-paint-product__price',money(price)));
        card.append(content);productGrid.append(card);entries.push({card,text:product.title.toLocaleLowerCase(locale)});
      });
    }else{
      Array.from(groups.keys()).sort((a,b)=>a.localeCompare(b,locale,{numeric:true})).forEach(model=>{
        const card=make('a','ns-paint-model');const url=new URL(location.href);url.searchParams.set('view','ns-paint-models');url.searchParams.set('model',model);card.href=url.href;
        card.append(make('span','ns-paint-model__brand',brand),make('h2','',model),make('span','ns-paint-model__action',`${root.dataset.choose} →`));
        modelGrid.append(card);entries.push({card,text:model.toLocaleLowerCase(locale)});
      });
    }
    const filter=()=>{let count=0;const term=search.value.trim().toLocaleLowerCase(locale);entries.forEach(entry=>{entry.card.hidden=!entry.text.includes(term);if(!entry.card.hidden)count++;});status.textContent=count?'':root.dataset.empty;};
    search.addEventListener('input',filter);filter();
  }catch(error){status.textContent=root.dataset.error;search.hidden=true;}
});
